var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanies(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.778809,
    width: 41.6947,
    height: 41.6947,
    rx: 11.8004,
    fill: "#FFE6D5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0391 15.5139C22.0849 15.1244 22.2748 14.7661 22.5714 14.5094C22.8679 14.2528 23.2498 14.1163 23.6418 14.1268C24.0339 14.1373 24.4079 14.294 24.6903 14.5662C24.9727 14.8384 25.1431 15.2063 25.168 15.5977",
    stroke: "#F97210",
    strokeWidth: 1.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7559 20.3608L15.7476 27.834C15.7966 28.192 15.9735 28.5201 16.2458 28.7576C16.518 28.9952 16.867 29.1261 17.2283 29.1261H24.3942C24.7555 29.1261 25.1045 28.9952 25.3767 28.7576C25.6489 28.5201 25.8259 28.192 25.8749 27.834L26.7828 21.0104L26.8666 20.3608",
    stroke: "#F97210",
    strokeWidth: 1.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8666 20.3608C26.1377 20.631 25.3909 20.8504 24.6317 21.0174C23.8388 21.1993 23.0333 21.3207 22.2221 21.3805C21.7611 21.4225 21.2862 21.4434 20.8252 21.4434H20.6995C19.9988 21.4404 19.2991 21.3938 18.6042 21.3037C17.7108 21.1943 16.8279 21.0121 15.9641 20.7589C15.573 20.6472 15.1749 20.5075 14.7559 20.3608",
    stroke: "#F97210",
    strokeWidth: 1.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9538 23.8879H17.668V26.6817H23.9538V23.8879Z",
    stroke: "#F97210",
    strokeWidth: 1.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6252 21.304C17.7318 21.1945 16.8489 21.0123 15.9851 20.7592L14.4137 17.8398C14.1721 17.395 14.1166 16.8726 14.2592 16.387C14.4019 15.9014 14.7312 15.492 15.175 15.2486C15.4544 15.0991 15.766 15.02 16.0829 15.0181C16.4315 15.0153 16.7743 15.1075 17.0745 15.2846C17.3747 15.4618 17.621 15.7174 17.7871 16.0239L18.7998 17.8957L20.6995 21.4297",
    stroke: "#F97210",
    strokeWidth: 1.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6508 17.26C20.6226 17.0528 20.6368 16.842 20.6925 16.6405C20.7482 16.4389 20.8443 16.2508 20.975 16.0875C21.1056 15.9242 21.268 15.7892 21.4524 15.6906C21.6368 15.592 21.8394 15.5319 22.0477 15.5139",
    stroke: "#F97210",
    strokeWidth: 1.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.168 15.5976C25.3388 15.5387 25.5181 15.508 25.6988 15.5068C26.0493 15.5116 26.3882 15.6334 26.6615 15.8529C26.9349 16.0724 27.127 16.377 27.2073 16.7182C27.2875 17.0595 27.2514 17.4178 27.1046 17.7361C26.9579 18.0545 26.7088 18.3146 26.3972 18.4752",
    stroke: "#F97210",
    strokeWidth: 1.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.418 18.4751C26.6408 18.59 26.8329 18.7564 26.9782 18.9607C27.1236 19.1649 27.218 19.4009 27.2535 19.6491C27.2891 19.8972 27.2647 20.1502 27.1826 20.3871C27.1004 20.6239 26.9628 20.8376 26.7812 21.0104",
    stroke: "#F97210",
    strokeWidth: 1.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8627 17.3647H16.1445",
    stroke: "#F97210",
    strokeWidth: 1.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7146 18.95H17.1641",
    stroke: "#F97210",
    strokeWidth: 1.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7988 17.8956C19.2494 17.4736 19.8437 17.2389 20.4611 17.2391H20.6497C21.0693 17.2737 21.4728 17.4169 21.8205 17.6544C22.1682 17.8919 22.4483 18.2157 22.6332 18.594C22.8131 18.9365 22.9066 19.3177 22.9056 19.7045C22.9029 20.3356 22.652 20.9402 22.2072 21.3878C23.2688 20.9757 24.0859 16.9946 24.0859 16.9946",
    stroke: "#F97210",
    strokeWidth: 1.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanies);
export default __webpack_public_path__ + "static/media/companies.840c8d836d3ba6026c27d215173c370c.svg";
export { ForwardRef as ReactComponent };